//
//
//
//
//
//
//
//

import drawMixin from '../pages/chatOnline/drawMixin';
export default {
  mixins: [drawMixin],
  data() {
    return {
      showRightWidow: true,
    };
  },
  mounted() {},
  methods: {},
};
